import React from "react";
import {Card, Col, Row, Container} from "react-bootstrap";
import NCgames from "../Projects/NCgames.png";
import NCmarketplace from "../Projects/NCmarketplace.png";
import NCgamesApi from "../Projects/NCgamesApi.png";
import Dictionary from "../Projects/Dictionary.jpeg";

export const Projects = () => {
	return (
		<div id='projects'>
			
			<div className='title-container'>
			<h2 className='section-title'>Projects</h2>
				<div className='title-line'></div>
			</div>
			<div className='project-section-title-container'>
				<div className="project-section-title-line"></div>
				<h3 className='project-section'>Frontend</h3>
				</div>
<div >
			<Row xs={1} md={2} className='g-4 grid-row d-flex justify-content-center' >
				<Col className='grid-colomn p-5'>
					<Card style={{width: "27rem"}}>
						<Card.Img variant='top' src={NCgames} className='project-img' fluid />
						<Card.Body>
							<Card.Title>NC-Games</Card.Title>
							<Card.Text>
							This project is a Reddit like page where you can
									like and comment on game reviews. Likewise you can dislike game reviews and delete comments.
							</Card.Text>
							<Card.Body>
								<Card.Link
									href=' https://62eea197f3c82a653fad3fe9--musaissa15-makes-great-sites.netlify.app'
									target='_blank'
									rel='noreferrer'
									className='project-links g-teal'>
									Project
								</Card.Link>
								<Card.Link
									href='https://github.com/musaissa15/front-end-nc-games-musa'
									target='_blank'
									rel='noreferrer'
									className='project-links'>
									GitHub
								</Card.Link>
							</Card.Body>
						</Card.Body>
					</Card>

				</Col>
				<Col className='grid-colomn p-5'>
				
				<Card style={{width: "27rem"}}>
					<Card.Img variant='top' src={Dictionary} className='project-img'  fluid/>
					<Card.Body>
						<Card.Title>Dictonary</Card.Title>
						<Card.Text>
						This project is website that information of the word searched through the search bar.
						</Card.Text>
						<Card.Body>
							<Card.Link
								href='https://main.d3flphqftk5jo2.amplifyapp.com/'
								target='_blank'
								rel='noreferrer'
								className='project-links g-teal'>
								Project
							</Card.Link>
							<Card.Link
								href='https://github.com/musaissa15/Dictonary-App-TS'
								target='_blank'
								rel='noreferrer'
								className='project-links'>
								GitHub
							</Card.Link>
						</Card.Body>
					</Card.Body>
				</Card>
			</Col>
				
			
				
			</Row>
			<div className='project-section-title-container'>
				<div className="project-section-title-line"></div>
			<h3 className='project-section'>Backend</h3>
				</div>
			
			<Row xs={1} md={2} className='g-4 grid-row'>
				<Col className='grid-colomn p-5'>
					
					<Card style={{width: "27rem"}}>
						<Card.Img variant='top' src={NCgamesApi}  className='project-img img-fluid' fluid />
						<Card.Body>
							<Card.Title>NC-Games API</Card.Title>
							<Card.Text>
								This project is the API of the NC-Games above.
								The API handles posted comments and deleted
								comments. Furthermore this API holds the users
								and the games reviews.
							</Card.Text>
							<Card.Body>
								<Card.Link
									href='https://musasgamesapi.herokuapp.com/api'
									target='_blank'
									rel='noreferrer'
									className='project-links '>
									Project
								</Card.Link>
								<Card.Link
									href='https://github.com/musaissa15/back-end-nc-games-musa'
									target='_blank'
									rel='noreferrer'
									className='project-links'>
									GitHub
								</Card.Link>
							</Card.Body>
						</Card.Body>
					</Card>
				</Col>
				</Row>
				</div>
		</div>
	);
};

// !! frontend project link
//!! https://62eea197f3c82a653fad3fe9--musaissa15-makes-great-sites.netlify.app
